import React, { useState } from "react";
import OperationsPage from "./OperationsPage";
import { YearNavigator } from "../../components/shared/Navigators";
import ThreadedRows from "../../components/shared/ThreadedRows";

const STATUS = ["Not Started", "Attempted", "In Progress", "Completed", "Cancelled", "Rescheduled", "No-Show", "Waiting on Response"];
const OUTCOMES = ["No Answer", "Left Voicemail", "Spoke to Contact", "Follow-Up Needed", "Appointment Set", "Interested", "Not Interested", "Call Back Later", "Wrong Number", "Referral Received", "Referral Given"];

const FIELDS = [
  { name: "date", label: "Date", type: "date" },
  { name: "time", label: "Time", type: "time" },
  { name: "company", label: "Company" },
  { name: "individual", label: "Individual" },
  { name: "phone", label: "Phone Number" },
  { name: "email", label: "Email" },
  { name: "call_type", label: "Call Type" },
  { name: "purpose", label: "Purpose" },
  { name: "outcome", label: "Outcome", type: "select", options: OUTCOMES },
  { name: "duration", label: "Duration (min)", type: "number" },
  { name: "notes", label: "Notes", type: "textarea", full: true },
  { name: "follow_up", label: "Follow Up", full: true },
  { name: "follow_up_date", label: "Follow Up Date", type: "date" },
  { name: "status", label: "Status", type: "select", options: STATUS },
  { name: "priority", label: "Priority", type: "select", options: ["Normal", "Priority"] },
];

// Same categories as the Daily To-Do list, in the same order, minus:
//   Administrative, Deals in Process - Commercial, Deals in Process - Residential,
//   Professional Introductions Given, Professional Introductions Received,
//   Vistage, Chambers.
const CATS = [
  { key: "Meeting / Appointments", color: "#0090FF" },
  { key: "Prospects - Commercial", color: "#FFC53D" },
  { key: "Prospects - Residential", color: "#FFC53D" },
  { key: "COIs", color: "#46A758" },
  { key: "Realtors / Real Estate Professionals", color: "#46A758" },
  { key: "Pennsylvania EXP Realtors", color: "#46A758" },
  { key: "Other Real Estate Professionals", color: "#46A758" },
  { key: "Provisors", color: "#8E4EC6" },
  { key: "The Connective", color: "#8E4EC6" },
  { key: "Other Networking", color: "#8E4EC6" },
  { key: "Lending Partners - Commercial", color: "#0E7AB2" },
  { key: "Lending Partners - Residential", color: "#0E7AB2" },
  { key: "Fiorenza's Food for Friends", color: "#E54D2E" },
  { key: "LinkedIn", color: "#0067B8" },
].map((c) => ({ ...c, label: c.key, fields: FIELDS }));

// Columns are only used by the fallback table view; the threaded view has its own header.
const COLUMNS = [];

export default function CallingActivity() {
  const now = new Date();
  const [value, setValue] = useState(String(now.getFullYear()));
  return (
    <OperationsPage
      kind="calling"
      title="YTD Calling Activity"
      eyebrow="Operations"
      dot="var(--rw-dot-calling)"
      description="Year-to-date outbound touches — repeat outreach to the same contact is threaded so you can see the whole conversation history."
      scope={{
        type: "year",
        value,
        setValue,
        Navigator: <YearNavigator value={value} onChange={setValue} />,
      }}
      defaultCategories={CATS}
      getFieldsFor={() => FIELDS}
      columns={COLUMNS}
      renderRows={(rows, { onRowClick }) => (
        <ThreadedRows rows={rows} onRowClick={onRowClick} />
      )}
    />
  );
}
